import { QuoteSchema } from '../../classes/Api/Invoice'
import Moment from 'moment'

export default {
    methods: {
        bookingTasksComplete(booking = null) {
            if (booking) {
                let tasks = booking.tasks

                for (let i in tasks) {
                    if (!tasks[i].completed_at) {
                        return false
                    }
                }

                return true
            }

            return false
        },
        showQuote(booking) {
            let quote;

            if (booking.quote) {
                quote = booking.quote
            } else {
                quote = new QuoteSchema({
                    contact_id: booking.contact_id,
                    contact: booking.contact,
                    instance_id: booking.instance_id,
                    instance: booking.instance,
                    tax_at: (new Moment()).toDate(),
                    team_id: booking.team_id,
                    team: booking.team
                })
            }

            this.$refs.quote.open(quote)
        }
    }
}